import { IconProps } from '../../modules/icons/IconProps';

export function ThermometerState0(props: IconProps) {
    return (
        <svg
            {...props}
            width="80"
            height="354"
            viewBox="0 0 80 354"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M40 0C51.0457 0 60 8.95431 60 20V279.353C71.9557 286.269 80 299.195 80 314C80 336.091 62.0914 354 40 354C17.9086 354 0 336.091 0 314C0 299.195 8.04427 286.269 20 279.353V20C20 8.95431 28.9543 0 40 0Z"
                fill="#F5F5F5"
            />
            <path
                d="M26.2422 314H76C75.9997 333.882 59.8821 350 40 350C20.1179 350 4.00026 333.882 4 314H19.375C21.5395 314.067 23.8477 314.076 26.2422 314ZM4 312.5C4.02503 312.505 10.4599 313.719 19.3203 313.998H4V312.5ZM40 312.5C57.5 308.999 76 312.5 76 312.5V313.998H26.3047C30.7009 313.856 35.3853 313.423 40 312.5Z"
                fill="#B0E2C4"
            />
        </svg>
    );
}
